import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { DataService } from "../../../../shared/services/municipios.service";
import { SedesService } from "../../../../shared/services/sedes.service";

@Component({
  selector: "app-diagnostico-pesv",
  templateUrl: "./diagnostico.component.html",
  styleUrls: ["./diagnostico.component.scss"],
})
export class DiagnosticoPesvComponent implements OnInit {
  formularioDiagnostico!: FormGroup;
  formularioEditarSede!: FormGroup;
  guardando = false;
  guardandoEdicion = false;
  cargandoListado = false;
  tabActiva = 1;
  municipios: any[] = [];
  sedes: any[] = [];
  sedesFiltradas: any[] = [];
  sedeEditandoId: number | null = null;
  filtro = "";
  filtroEstado: number | null = null;
  pageSize = 10;
  page = 1;

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private dataService: DataService,
    private sedesService: SedesService,
  ) {}

  ngOnInit(): void {
    this.formularioDiagnostico = this.crearFormularioSede();
    this.formularioEditarSede = this.crearFormularioSede();

    this.cargarMunicipios();
  }

  private crearFormularioSede(): FormGroup {
    return this.fb.group({
      nombre_sede: ["", [Validators.required, Validators.maxLength(250)]],
      ciudad_municipio: [null, [Validators.required]],
      sede_administrada: ["", [Validators.required, Validators.maxLength(250)]],
      direccion: ["", [Validators.required, Validators.maxLength(250)]],
      telefono: ["", [Validators.required, Validators.pattern(/^[0-9]+$/), Validators.minLength(7), Validators.maxLength(10)]],
      cuenta_vias: [null, [Validators.required]],
      cuenta_rutas_transporte: [null, [Validators.required]],
    });
  }

  get f() {
    return this.formularioDiagnostico.controls;
  }

  get fe() {
    return this.formularioEditarSede.controls;
  }

  onTabChange(event: any): void {
    this.tabActiva = event.nextId;
    if (this.tabActiva === 2) {
      this.cargarListadoSedes();
    }
  }

  guardarDiagnostico(): void {
    if (this.formularioDiagnostico.invalid) {
      this.formularioDiagnostico.markAllAsTouched();
      Swal.fire("Advertencia", "Completa los campos obligatorios del diagnostico.", "warning");
      return;
    }

    this.guardando = true;
    const payload = this.construirPayload(this.formularioDiagnostico.value);

    this.sedesService.create(payload).subscribe({
      next: () => {
        this.guardando = false;
        Swal.fire("Exito", "Sede guardada correctamente.", "success");
        this.limpiarFormulario();
        this.cargarListadoSedes();
      },
      error: (err) => {
        this.guardando = false;
        console.error("Error guardando sede PESV:", err);
        Swal.fire("Error", "No se pudo guardar la sede.", "error");
      },
    });
  }

  abrirModalEditar(content: any, sede: any): void {
    const idSede = Number(sede?.id);
    if (!idSede) {
      Swal.fire("Advertencia", "No se pudo identificar la sede para editar.", "warning");
      return;
    }

    this.sedeEditandoId = idSede;
    this.formularioEditarSede.reset({
      nombre_sede: String(sede?.nombre_sede || ""),
      ciudad_municipio: Number(sede?.ciudad_municipio ?? sede?.ciudad ?? null),
      sede_administrada: String(sede?.sede_administrada || ""),
      direccion: String(sede?.direccion || ""),
      telefono: String(sede?.telefono || ""),
      cuenta_vias: this.normalizarSiNoABinario(sede?.cuenta_vias),
      cuenta_rutas_transporte: this.normalizarSiNoABinario(sede?.cuenta_rutas_transporte),
    });

    this.modalService.open(content, {
      size: "xl",
      centered: true,
      backdrop: "static",
    });
  }

  guardarEdicion(modal: any): void {
    if (!this.sedeEditandoId) {
      Swal.fire("Advertencia", "No hay una sede seleccionada para editar.", "warning");
      return;
    }

    if (this.formularioEditarSede.invalid) {
      this.formularioEditarSede.markAllAsTouched();
      Swal.fire("Advertencia", "Completa los campos obligatorios para editar la sede.", "warning");
      return;
    }

    this.guardandoEdicion = true;
    const payload = this.construirPayload(this.formularioEditarSede.value);

    this.sedesService.update(this.sedeEditandoId, payload).subscribe({
      next: () => {
        this.guardandoEdicion = false;
        modal.close();
        Swal.fire("Exito", "Sede actualizada correctamente.", "success");
        this.cargarListadoSedes();
      },
      error: (err) => {
        this.guardandoEdicion = false;
        console.error("Error editando sede PESV:", err);
        Swal.fire("Error", "No se pudo actualizar la sede.", "error");
      },
    });
  }

  inactivarSede(sede: any): void {
    const idSede = Number(sede?.id);
    if (!idSede) {
      Swal.fire("Advertencia", "No se pudo identificar la sede para inactivar.", "warning");
      return;
    }

    Swal.fire({
      title: "INACTIVAR",
      text: `¿Desea inactivar la sede ${sede?.nombre_sede || "seleccionada"}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }
      this.actualizarEstadoSede(idSede, false);
    });
  }

  activarSede(sede: any): void {
    const idSede = Number(sede?.id);
    if (!idSede) {
      Swal.fire("Advertencia", "No se pudo identificar la sede para activar.", "warning");
      return;
    }

    Swal.fire({
      title: "ACTIVAR",
      text: `¿Desea activar la sede ${sede?.nombre_sede || "seleccionada"}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }
      this.actualizarEstadoSede(idSede, true);
    });
  }

  private actualizarEstadoSede(idSede: number, activar: boolean): void {
    const request$ = activar
      ? this.sedesService.activate(idSede)
      : this.sedesService.inactivate(idSede);

    request$.subscribe({
      next: () => {
        Swal.fire(
          "Exito",
          activar ? "Sede activada correctamente." : "Sede inactivada correctamente.",
          "success",
        );
        this.cargarListadoSedes();
      },
      error: (err) => {
        console.error("Error actualizando estado de sede:", err);
        Swal.fire(
          "Error",
          activar ? "No se pudo activar la sede." : "No se pudo inactivar la sede.",
          "error",
        );
      },
    });
  }

  private construirPayload(formValue: any): any {
    const ciudadSeleccionada = Number(formValue.ciudad_municipio);
    const cuentaVias = this.normalizarSiNoABinario(formValue.cuenta_vias);
    const cuentaRutas = this.normalizarSiNoABinario(formValue.cuenta_rutas_transporte);

    return {
      nombre_sede: String(formValue.nombre_sede || "").trim().toUpperCase(),
      ciudad_municipio: ciudadSeleccionada,
      sede_administrada: String(formValue.sede_administrada || "").trim().toUpperCase(),
      direccion: String(formValue.direccion || "").trim().toUpperCase(),
      telefono: Number(formValue.telefono),
      cuenta_vias: cuentaVias,
      cuenta_rutas_transporte: cuentaRutas,
    };
  }

  private normalizarSiNoABinario(valor: any): number {
    const v = String(valor ?? "").trim().toUpperCase();
    if (v === "SI" || v === "SÍ" || v === "1") {
      return 1;
    }
    return 0;
  }

  private cargarMunicipios(): void {
    this.dataService.getDatos().subscribe({
      next: (data) => {
        this.municipios = Array.isArray(data) ? data : [];
      },
      error: (err) => {
        console.error("Error cargando municipios para diagnostico PESV:", err);
        this.municipios = [];
      },
    });
  }

  cargarListadoSedes(): void {
    this.cargandoListado = true;
    this.sedesService.getAll().subscribe({
      next: (res: any) => {
        const lista = Array.isArray(res)
          ? res
          : Array.isArray(res?.data)
            ? res.data
            : Array.isArray(res?.sedes)
              ? res.sedes
              : [];
        this.sedes = lista;
          this.aplicarFiltro();
        this.cargandoListado = false;
      },
      error: (err) => {
        console.error("Error cargando listado de sedes:", err);
        this.sedes = [];
          this.sedesFiltradas = [];
        this.cargandoListado = false;
        Swal.fire("Error", "No se pudo cargar el listado de sedes.", "error");
      },
    });
  }

    aplicarFiltro(): void {
      const termino = String(this.filtro || "").toLowerCase().trim();

      this.sedesFiltradas = this.sedes.filter((sede) => {
        const textoCoincide =
          !termino ||
          [
            sede.id,
            sede.nombre_sede,
            sede.sede_administrada,
            sede.direccion,
            sede.telefono,
            this.obtenerNombreMunicipio(sede.ciudad_municipio ?? sede.ciudad),
          ]
            .filter((valor) => valor !== null && valor !== undefined)
            .some((valor) => String(valor).toLowerCase().includes(termino));

        const estadoSede = Number(sede.estado);
        const estadoCoincide = this.filtroEstado === null || estadoSede === this.filtroEstado;

        return textoCoincide && estadoCoincide;
      });

      this.page = 1;
    }

  obtenerNombreMunicipio(idMunicipio: any): string {
    const id = Number(idMunicipio);
    const encontrado = this.municipios.find((m) => Number(m.IDMUN) === id);
    if (!encontrado) {
      return String(idMunicipio ?? "N/A");
    }
    const departamento = encontrado?.departamento?.nombre
      ? ` (${encontrado.departamento.nombre})`
      : "";
    return `${encontrado.MUNICIPIO}${departamento}`;
  }

  esSedeActiva(estado: any): boolean {
    return Number(estado) === 1;
  }

  exportarListadoSedesExcel(): void {
    const datos = this.sedesFiltradas || [];
    if (!datos.length) {
      Swal.fire("Info", "No hay datos para exportar.", "info");
      return;
    }

    const filas = datos.map((sede: any) => ({
      ID: sede?.id ?? "",
      NOMBRE_SEDE: sede?.nombre_sede || "",
      CIUDAD_MUNICIPIO: this.obtenerNombreMunicipio(sede?.ciudad_municipio ?? sede?.ciudad),
      SEDE_ADMINISTRADA: sede?.sede_administrada || "",
      DIRECCION: sede?.direccion || "",
      TELEFONO: sede?.telefono ?? "",
      CUENTA_VIAS_INTERNAS: Number(sede?.cuenta_vias) === 1 ? "SI" : "NO",
      CUENTA_RUTAS_TRANSPORTE: Number(sede?.cuenta_rutas_transporte) === 1 ? "SI" : "NO",
      ESTADO: this.esSedeActiva(sede?.estado) ? "ACTIVA" : "INACTIVA",
    }));

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filas);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sedes");
    XLSX.writeFile(wb, `listado_sedes_${Date.now()}.xlsx`);
    Swal.fire("Exito", "Exportacion a Excel completada.", "success");
  }

  exportarListadoSedesPdf(): void {
    const datos = this.sedesFiltradas || [];
    if (!datos.length) {
      Swal.fire("Info", "No hay datos para exportar.", "info");
      return;
    }

    const doc = new jsPDF("p", "pt");
    doc.setFontSize(12);
    doc.text("Listado de Sedes PESV", 40, 35);

    autoTable(doc, {
      head: [["ID", "NOMBRE", "CIUDAD/MUNICIPIO", "SEDE ADM.", "DIRECCION", "TELEFONO", "VIAS", "RUTAS", "ESTADO"]],
      body: datos.map((sede: any) => [
        sede?.id ?? "",
        sede?.nombre_sede || "",
        this.obtenerNombreMunicipio(sede?.ciudad_municipio ?? sede?.ciudad),
        sede?.sede_administrada || "",
        sede?.direccion || "",
        sede?.telefono ?? "",
        Number(sede?.cuenta_vias) === 1 ? "SI" : "NO",
        Number(sede?.cuenta_rutas_transporte) === 1 ? "SI" : "NO",
        this.esSedeActiva(sede?.estado) ? "ACTIVA" : "INACTIVA",
      ]),
      startY: 50,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [13, 110, 253] },
    });

    doc.save(`listado_sedes_${Date.now()}.pdf`);
    Swal.fire("Exito", "Exportacion a PDF completada.", "success");
  }

  limpiarFormulario(): void {
    this.formularioDiagnostico.reset({
      sede_administrada: "",
      cuenta_vias: null,
      cuenta_rutas_transporte: null,
    });
  }
}
